// The tracker's URL state, built from the column definitions the API serves rather than from a
// list spelled here (AC9). Which columns sort is whatever the leg stores: a derived column is
// computed on read and has no stored value to order by, so it is not offered - the server's
// parse_sort refuses it, and the URL reader here falls back to the default instead of sending it.
//
// Two sort keys belong to the row rather than to a column - `id` and `created`, mirroring
// trex/deliveries/register.py - and `created` descending is the default, because newest first is
// what a tracker opens on. They are the only labels the tracker spells: row metadata, not columns.
//
// A filter on any stored column (TX-US-0020): a set of accepted values, carried as `f.<key>`
// repeated so a view is a link, and changing one drops the cursor because the server binds a
// cursor to the filter set it was minted under. Which columns filter is which columns store -
// the same rule as sorting, for the same reason: a derived column has nothing stored to match.

import { createTableUrl } from '../ui/tableUrl.js';

export const ROW_COLUMNS = Object.freeze({
  id: Object.freeze({ key: 'id', label: 'ID', defaultDirection: 'asc' }),
  created: Object.freeze({ key: 'created', label: 'Created', defaultDirection: 'desc' }),
});

// What can be sorted on, in the table's order: the identifier, the stored columns, the creation
// date. The table's headers and the tiles' sort control are both this list.
export const sortOptions = (columns) => [
  ROW_COLUMNS.id,
  ...columns
    .filter((column) => !column.derived)
    .map((column) => ({ key: column.key, label: column.label, defaultDirection: 'asc' })),
  ROW_COLUMNS.created,
];

// What can be filtered on: the stored columns, in the order the API serves them. The headers'
// funnels and the tiles' control are both this list.
export const filterColumns = (columns) => columns.filter((column) => !column.derived);

export const filterKeys = (columns) => filterColumns(columns).map((column) => column.key);

export function trackerUrl(columns) {
  return createTableUrl({
    columns: sortOptions(columns),
    defaultSort: ROW_COLUMNS.created.key,
    multiFilters: filterKeys(columns),
  });
}
